import React from "react";

function Docs() {
  return (
    <div className="container-md my-5">
      <h2 className="mb-4 text-center">Documentación de Turnora</h2>
      <p className="text-center text-muted">
        Guía completa de uso para empresas, administradores y empleados.
      </p>

      <hr className="my-4" />

      <h3 className="mt-5">1. Registro de empresa y usuario administrador</h3>
      <p>
        Para registrar tu empresa, accede al siguiente enlace:
        <br />
        <a
          href="https://app.turnora.es/register"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://app.turnora.es/register
        </a>
      </p>
      <p>
        Rellena los datos de la empresa y, a continuación, los del{" "}
        <strong>usuario administrador</strong>. Este usuario es el principal o
        “maestro”, y tendrá permisos para crear otros usuarios (empleados o
        administradores adicionales).
      </p>

      <h3 className="mt-5">2. Panel de control de administración</h3>
      <p>
        Al iniciar sesión con el usuario administrador, accederás al panel de
        gestión completo de la empresa. Desde aquí podrás administrar todos los
        aspectos de Turnora:
      </p>

      <ul>
        <li>
          <strong>Dashboard:</strong> Muestra datos generales como usuarios
          activos, fichajes del día actual e incidencias pendientes.
        </li>
        <li>
          <strong>Empresa:</strong> Permite modificar los datos introducidos
          durante el registro en caso de error.
        </li>
        <li>
          <strong>Empleados:</strong> Desde el botón <em>“+ Nuevo”</em> podrás
          crear nuevos usuarios y asignarles su rol (administrador o empleado).
        </li>
        <li>
          <strong>Fichajes:</strong> Muestra por defecto los fichajes del día
          actual. Puedes aplicar filtros por fecha, empleado, nombre o DNI. Cada
          fichaje incluye un botón <em>“Ver”</em> que abre la ubicación en Google
          Maps.
        </li>
        <li>
          <strong>Fichar:</strong> Permite registrar:
          <ul>
            <li>
              <strong>Entrada:</strong> al iniciar la jornada laboral.
            </li>
            <li>
              <strong>Descanso:</strong> al iniciar y finalizar una pausa.
            </li>
            <li>
              <strong>Salida:</strong> al finalizar la jornada laboral.
            </li>
          </ul>
          En la parte superior se puede marcar una <strong>incidencia</strong>
          (falta o retraso) asociada a un fichaje, con un texto explicativo para
          que los administradores vean el motivo.
        </li>
        <li>
          <strong>Incidencias:</strong> Muestra todas las incidencias creadas.
          Puedes filtrarlas por estado (por defecto se muestran las pendientes).
        </li>
      </ul>

      <h3 className="mt-5">3. Panel de usuario (empleado)</h3>
      <p>
        El usuario estándar dispone de un panel simplificado con tres secciones
        principales:
      </p>

      <ul>
        <li>
          <strong>Editar perfil:</strong> Permite actualizar datos personales
          como nombre, contraseña o teléfono.
        </li>
        <li>
          <strong>Fichar:</strong> Incluye los botones de{" "}
          <strong>Entrada</strong>, <strong>Descanso</strong> y{" "}
          <strong>Salida</strong>, con el mismo funcionamiento que el panel del
          administrador.
        </li>
        <li>
          <strong>Mis incidencias:</strong> Permite consultar el estado de las
          incidencias (pendientes, resueltas, etc.).
        </li>
      </ul>

      <h3 className="mt-5 text-center">
        ¿Tienes alguna duda? Escríbenos a{" "}
        <a href="mailto:soporte@turnora.es" className="text-primary">
          soporte@turnora.es
        </a>
      </h3>

      <hr className="my-4" />

      {/* Fecha de actualización */}
      <p className="text-center text-muted small mb-2">
        Última actualización: <strong>7 de noviembre de 2025</strong>
      </p>
      {/* <p className="text-center text-muted small">
        Desarrollado por <strong>Alejandro Martín González</strong>
      </p> */}

    </div>
  );
}

export default Docs;
